import {
  FormValidator,
  FormValidatorBase,
} from "@/app/dynamic-components/forms/form-validations/form-validator.base";
import {DynamicFormEntry} from "@/app/dynamic-components/forms/dynamic-form.model";
import {ruleEngine} from "@/app/services/rule.engine";

export default class RuleFormValidator extends FormValidatorBase {
  constructor() {
    super("ruleError", "%param1%");
  }

  isValid(formData: any, entry: DynamicFormEntry): boolean {
    if(!entry?.root?.externalContext) return true;
    const isError = ruleEngine.resolveRule(entry.root.externalContext, this.params[0]);
    return !isError;
  }

  constructImpl(params: any[]): FormValidator {
    const validator = new RuleFormValidator();
    validator.params = params;
    return validator;
  }
}
